import React from 'react'
import './Header.css';
import { useNavigate } from 'react-router-dom';
function Header({data,changeUser}) {
  const navigate=useNavigate()
  const logOutUser=()=>{
    localStorage.setItem('loggedInUser','')
    navigate('/');
  }
  return (
    <nav>
    <div className='container-fluid'>
        <div className='d-flex justify-content-between py-3'>
        <h1 className='header_h1'>Hello <span style={{fontSize:"30px"}}>&#x1F44B;</span><br/> <span className='emp_name'>{data?data.name:"admin"}</span> </h1>
        <button onClick={logOutUser} className='logout'>Logout</button>
        </div>
    </div>
    </nav>
  )
}

export default Header